import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';

interface IPackageErrorMiscFeeModalProps {
  opened: boolean;
  onClose: () => void;
  blockingInvoice: string | null;
  onGoToInvoice: () => void;
  isChildPackageError: boolean;
  operation: 'cancel' | 'delete';
}

const OPERATION_CONFIG = {
  cancel: {
    pastTense: 'canceled',
    verb: 'cancel',
    title: 'Cancel Package',
  },
  delete: {
    pastTense: 'removed',
    verb: 'remove',
    title: 'Remove Package',
  },
} as const;

const PackageErrorMiscFeeModal = ({
  opened,
  onClose,
  blockingInvoice,
  onGoToInvoice,
  isChildPackageError,
  operation,
}: IPackageErrorMiscFeeModalProps): JSX.Element => {
  const { pastTense: operationPastTense, verb: operationVerb, title } = OPERATION_CONFIG[operation];

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size='lg'
      centered
      title={
        <Title order={4} pr='md'>
          {title}
        </Title>
      }
    >
      <Stack p='md'>
        {isChildPackageError ? (
          <>
            <Text ta='center'>
              This package cannot be {operationPastTense} because it has a child (renewal) package with an
              upcoming invoice with retail/misc items attached to it.
            </Text>
            <Text ta='center'>
              To {operationVerb} it, the retail/misc items should be removed from the child package&apos;s
              invoice.
            </Text>
          </>
        ) : (
          <>
            <Text ta='center'>
              This package cannot be {operationPastTense} because it has an upcoming invoice with retail/misc
              items attached to it.
            </Text>
            {operation === 'cancel' ? (
              <Text ta='center'>
                To cancel it, you can set a cancellation date after the invoice&apos;s due date, or remove
                the retail/misc items from the invoice.
              </Text>
            ) : (
              <Text ta='center'>
                To {operationVerb} it, the retail/misc items should be removed from the invoice.
              </Text>
            )}
          </>
        )}
        {blockingInvoice && (
          <Group position='center' mt='md'>
            <Button onClick={onGoToInvoice}>Go to Invoice</Button>
          </Group>
        )}
      </Stack>
    </Modal>
  );
};

export default PackageErrorMiscFeeModal;
